import { useQuery } from '@tanstack/react-query';
import { MANAGER_CONTRACTS_KEY } from 'src/utils/constants/queryKeys';
import { getManagerContacts } from '../services/fn-api/Company';

export const useGetManagerContacts = (companyId: number) => {
  return useQuery({
    queryKey: [MANAGER_CONTRACTS_KEY, companyId],
    queryFn: () => getManagerContacts(companyId),
    enabled: !!companyId,
  });
};
